export const aydinlatmaMetni = {
  title: 'Aydınlatma Metni',
  sections: [
    {
      heading: 'Veri Sorumlusu',
      paragraphs: [
        'Yol SepetiGO Teknoloji olarak kişisel verilerinizin korunmasına büyük önem vermekteyiz. 6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") kapsamında veri sorumlusu sıfatıyla bilgilendirme yapmaktayız.',
      ],
    },
    {
      heading: 'Kişisel Verilerin İşlenme Amacı',
      list: [
        'Hizmet süreçlerinin yürütülmesi',
        'Müşteri ilişkileri yönetimi',
        'Yasal yükümlülüklerin yerine getirilmesi',
        'İş güvenliği ve denetim faaliyetleri',
        'Pazarlama ve iletişim faaliyetleri (izninize bağlı)',
      ],
    },
    {
      heading: 'Kişisel Verilerin Aktarılması',
      paragraphs: [
        'Kişisel verileriniz, yasal zorunluluklar ve hizmet gereksinimleri doğrultusunda iş ortaklarımız, tedarikçilerimiz ve yetkili kamu kuruluşlarıyla paylaşılabilir.',
      ],
    },
    {
      heading: 'Haklarınız',
      paragraphs: [
        'KVKK\'nın 11. maddesi kapsamında; kişisel verilerinizin işlenip işlenmediğini öğrenme, düzeltme, silinmesini talep etme ve itiraz haklarına sahipsiniz.',
      ],
    },
  ],
};
